enum SportsbookSelectionTrackingTags {
	BETSLIP_RECOMMENDATIONS = 'BETSLIP_BET_RECOMMENDATIONS',
	EXPLORE_RECOMMENDATIONS = 'EXPLORE_BET_RECOMMENDATIONS',
	BETBUILDER_BET = 'BETBUILDER_BET',
	EVENT_PAGE = 'EVENT_PAGE',
	EVENT_PAGE_MORE_EVENTS = 'EVENT_PAGE_MORE_EVENTS',
	EXPLORE_LIVE = 'EXPLORE_PAGE_LIVE',
	EXPLORE_UPCOMING = 'EXPLORE_PAGE_UPCOMING',
	EXPLORE_POPULAR_LIVE = 'EXPLORE_PAGE_POPULAR_LIVE',
	EXPLORE_POPULAR_UPCOMING = 'EXPLORE_PAGE_POPULAR_UPCOMING',
	EXPLORE_PRE_CANNEDS = 'EXPLORE_PAGE_PRE_CANNEDS',
	EXPLORE_PROMOS = 'EXPLORE_PAGE_PROMOS',
	LEAGUE = 'LEAGUE_PAGE',
	LEAGUE_OUTRIGHTS = 'LEAGUE_PAGE_OUTRIGHTS',
	LEAGUE_PRE_CANNEDS = 'LEAGUE_PAGE_PRE_CANNEDS',
	LIVE = 'LIVE_PAGE',
	SEARCH = 'SEARCH_MODAL',
	SPORT = 'SPORT_PAGE',
	SPORT_UPCOMING = 'SPORT_PAGE_UPCOMING',
	SPORT_PRE_CANNEDS = 'SPORT_PAGE_PRE_CANNEDS',
	URL_GENERAL = 'URL_GENERAL',
	URL_DEPOSIT = 'URL_DEPOSIT',
	URL_FREE_TO_PLAY_HUB = 'URL_FREE_TO_PLAY_HUB'
}

export const mapStringToEnum = (tag: string) => {
	return (
		SportsbookSelectionTrackingTags[tag.toUpperCase() as keyof typeof SportsbookSelectionTrackingTags] ||
		'URL_GENERAL'
	);
};
export default SportsbookSelectionTrackingTags;
